import { render } from "./AvgSkuPerOutletChart.vue?vue&type=template&id=36a86cf8"
import script from "./AvgSkuPerOutletChart.vue?vue&type=script&lang=js"
export * from "./AvgSkuPerOutletChart.vue?vue&type=script&lang=js"

import "./AvgSkuPerOutletChart.vue?vue&type=style&index=0&id=36a86cf8&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__